








import { defineComponent } from '@vue/composition-api';

import AverageDeliveryTimeByArea from '@/components/Report/04-DeliveryTime/AverageDeliveryTimeByArea.vue';

const DeliveryTimeByArea = defineComponent({
  components: {
    AverageDeliveryTimeByArea,
  },
  // setup() {},
});

export default DeliveryTimeByArea;
